import request from "../../utils/request";
export const fetchArticleList = () => {
  return request.post("/supply/cms/homepage/list");
};

export const fetchFollowUs = () => {
  return request.post("/supply/cms/banner/follow_us");
};
